import { render, staticRenderFns } from "./BookingStepSelectQuota.vue?vue&type=template&id=02064d6a"
import script from "./BookingStepSelectQuota.vue?vue&type=script&lang=ts"
export * from "./BookingStepSelectQuota.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports